import { Button } from '@/components/atoms/Button/Button.styled';
import {
  FormInput,
  InputContainer,
} from '@/components/atoms/InputField/InputField.styled';
import { medias } from '@/utils/sizes';
import { generateClampFromMinMax } from '@/utils/styling';
import styled from 'styled-components';

export const ColMainFilters = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 var(--spacing-component-inner-sm) var(--spacing-component-inner-sm) 0;

  ${InputContainer} {
    margin-left: auto;
    opacity: 1;
    transition: opacity var(--tr-base);
  }

  ${medias.max.tablet} {
    padding: 0 !important;
  }

  ${medias.only.mobile} {
    width: 100%;
  }

  button.button-reset { 
    opacity: 0;

    &[data-is-hidden='false'] {
      opacity: 1;
    }
  }

  ${medias.only.mobile} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    ${InputContainer} {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 0;
      width: 100%;
      padding: var(--page-pd-mobile-tablet) 0;
      border-top: 1px solid var(--c-border);

      input {
        height: 50px;
        background: #ffffff;
        font-size: 16px;
      }
    }

    button.button-reset {
      height: 50px;
      padding-left: var(--page-pd-mobile-tablet);
      transition: opacity var(--tr-base);
      opacity: 1;

      span {
        font-size: var(--fs-xl);
        color: var(--c-font-primary);
      }

      &.has-selected-filters {
        color: var(--c-font-primary);
      }

      ${medias.only.mobile} {
        &.no-filters {
          opacity: 0.15;
          pointer-events: none;
        }
      }
    }

    button.button-close-filters {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      padding: 0 var(--page-pd-mobile-tablet);
    }
  }

  .separator {
    padding: 0 3px;
  }

  ${FormInput} {
    height: ${generateClampFromMinMax(40, 50)};
    background: none;
    border: 1px solid var(--c-border);
    outline: 1px solid transparent;
    padding: 0 20px;
    transition:
      border-color var(--tr-base),
      outline var(--tr-base);

    &:focus {
      border-color: var(--c-primary);
      outline: 1px solid var(--c-primary);
    }

    ${medias.only.mobile} {
      font-size: var(--fs-xl);
      width: calc(100% - (var(--page-pd-mobile-tablet) * 2));
      margin: auto 0;
    }
  }

    ${medias.only.tablet} {
      .search-fields-container {
        margin-bottom: 13px;
      }
    }

  ${Button} {
    justify-content: left;
    min-height: unset;
    white-space: nowrap;
    min-width: unset;

    &:hover span {
      color: var(--c-font-primary);
    }
  }

  &:first-child {
    padding-right: 3px;
  }
`;

export const InputFieldWrapper = styled.div`
  position: relative;
  margin-left: auto;

  svg, img {
    position: absolute;
    top: 50% !important;
    left: unset !important;
    right: 20px !important;
    height: 21px !important;
    width: 21px !important;
    transform: translateY(-50%);
  }

  input {
    padding-right: 45px !important;
  }

  ${medias.only.mobile} {
    width: 100%;

    svg, img {
      right: 30px !important;
    }
  }

  &[data-is-filled='true'] {
    > img {
      opacity: 0 !important;
    }
  }

  &[data-is-filled='false'] {
    button {
      opacity: 0;
      pointer-events: none;
    }
  }
`;

export const SearchFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-component-inner);

  ${medias.only.mobile} {
    border-top: 1px solid var(--c-border);
    padding: var(--page-pd-mobile-tablet) var(--page-pd-mobile-tablet) var(--page-pd-mobile-tablet) calc(var(--page-pd-mobile-tablet) * 2);
    width: 100%;

    ${InputContainer} {
      padding: 0;
      border-top: none;
    }
  }

  ${InputFieldWrapper} {
    width: 100%;
  }

  ${FormInput} {
    width: -webkit-fill-available;

  }

  ${medias.min.tablet} {
    position: absolute;
    padding: 0;
    right: 0;
    width: 66.66%;
    margin-left: auto;

    ${InputFieldWrapper} {
      width: 100%;
    }
  }

  ${medias.only.tablet} {
    width: 50%;

  }
`;

export const SearchFieldsGrid = styled.div`
  ${medias.min.tablet} {
    display: grid;
    grid-column-gap: var(--spacing-component-inner);
    grid-template-columns: 1fr 1fr;
    margin-left: var(--spacing-component-inner-half);

    input {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  ${medias.max.mobile} {
    > div:first-child {
      margin-bottom: 5px;
    } 
  }
`;
